// extracted by mini-css-extract-plugin
export default {"medium":"768px","large":"991px","extraLarge":"1280px","xxl":"1440px"};